module.exports = __webpack_public_path__ + "img/calligraphy-work-icon3.aff3fd74.jpg";